export interface CommentPayload {
  comment: string;
  path: string;
  companyId?: string | null;
}

export const blacklistViewComment = [
  "/",
  "/setting",
  "/setting/masterdata",
  "/setting/company",
  "/setting/user-management",
  "/setting/job",
  "/setting/history",
  "/vocs-inventory",
  "/my-task",
];
